import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
  },
  realtime: {
    params: { eventsPerSecond: 10 },
  },
});

// Seed default data for new users
export async function seedUserDefaults(userId) {
  const { error } = await supabase.rpc('seed_user_defaults', { p_user_id: userId });
  if (error) console.error('Seed error:', error);
}

export default supabase;
